import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { ActionsEl } from "./Modal.styles";
import type { ModalActionsProps } from "./Modal.types";
import { useModalContext } from "./ModalContext";

const ModalActionsComponent = (props: ModalActionsProps): ReactElement => {
  const { children, content, className, style } = props;
  const { basic } = useModalContext();
  return (
    <ActionsEl className={cx(className)} style={style} $basic={basic}>
      {children ?? content}
    </ActionsEl>
  );
};

export const ModalActions = styled(ModalActionsComponent)``;
